import { ajax } from '../../../services/helper'
class ApiService {

    getDesignationsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/designations/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addDesignations = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/designations/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getDesignationsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/designations/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editDesignations = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/designations/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Designations/services/apiservices.js